// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1MWNM","approved":"Status_approved__Pg4US","rejected":"Status_rejected__91rjz","expired":"Status_expired__Nrxpd","label":"Status_label__1aq4c"};